import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isSuperAdmin } from '../../Utils/superAdminAccess';
import { getDashboardPath } from '../../Utils/authStorage';

function SuperAdminRoute({ component: Component, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [allowed, setAllowed] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAccess = () => {
      try {
        const token = localStorage.getItem('token');
        if (!token || token === 'null' || token === 'undefined') {
          navigate('/login', { state: { from: location }, replace: true });
          return;
        }

        const parsedToken = JSON.parse(token);
        if (!parsedToken) {
          localStorage.clear();
          navigate('/login', { state: { from: location }, replace: true });
          return;
        }

        if (!isSuperAdmin()) {
          navigate(getDashboardPath(), { replace: true });
          return;
        }

        setAllowed(true);
      } catch (error) {
        console.error('Super admin auth check error:', error);
        localStorage.clear();
        navigate('/login', { state: { from: location }, replace: true });
      } finally {
        setIsChecking(false);
      }
    };

    checkAccess();
  }, [navigate, location]);

  if (isChecking) return null;
  return allowed ? <Component {...rest} /> : null;
}

export default SuperAdminRoute;
